<template>
<div v-if="current">
    <messageModal v-if="showMessage" message="Le rapport a été mis à jour" @closeMessage="showMessage = false"></messageModal>
    <div class="large-3 columns">
            <div class="note">les champs marqués d'un * sont optionnels</div>
    </div>
    <table>
        <thead class="roster-head">
            <tr>
                <th width="15%">Nom du champion</th>
                <th width="5%">TD</th>
                <th width="5%">Réu</th>
                <th width="5%">Sor</th>
                <th width="5%">Int</th>
                <th width="6%">JPV</th>
                <th width="5%">Agro*</th>
                <th width="5%">Expulsion*</th>
                <th width="15%">Blessure</th>
                <th width="4%"></th>
            </tr>
        </thead>
        <tbody class="roster">
        <tr v-for="action of star_actions">
                <td class="small-input">
                    <input type="text" placeholder="puggy" min="0" class="line_input" v-model="action.star_name">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="action.nb_td">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="action.nb_pass">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="action.nb_cas">
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="action.nb_int">
                </td>
                <td class="small-input">
                    <select name="" id="" class="line_input" v-model="action.mvp">
                        <option v-bind:value="true">oui</option>
                        <option v-bind:value="false">non</option>
                    </select>
                </td>
                <td class="small-input">
                    <input type="number" min="0" class="line_input" v-model="action.nb_foul">
                </td>
                <td class="small-input">
                    <select name=""
                        id=""
                        class="line_input" v-model="action.nb_red_card">
                        <option v-bind:value="0">non</option>
                        <option v-bind:value="1">oui</option>
                    </select>
                </td>
                <td class="small-input">
                    <select name="" id="" class="line_input" v-model="action.injury_type">
                        <option value="null">pas de blessure</option>
                        <option value="0">Commotion</option>
                        <option value="1">Manque le prochain match</option>
                        <option value="2">Blessure persistante</option>
                        <option value="4">-1 en Armure</option>
                        <option value="3">-1 en Mouvement</option>
                        <option value="5">-1 en Agilité</option>
                        <option value="6">-1 en Force</option>
                        <option value="7">la MOOOORT</option>
                    </select>
                </td>
                <td class="small-input">
                    <button class="small alert" :id="action.front_id" @click="removeActionLine($event)">
                        <i class="fa fa-trash-o" aria-hidden="true"></i>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
    <div class="row">
        <div class="large-3 columns">
            <button @click="addActionLine" class="full-width">Ajouter une ligne</button>
        </div>
        <div class="large-2 columns">
            <button  @click="validate(true)" class="full-width">Enregistrer</button>
        </div>
    </div>
</div>
<div v-else>
<spinner></spinner>
</div>
</template>

<script>
import spinner from '../common/spinner.vue'
import wizard from '../common/wizard.vue'
import { mapGetters } from 'vuex'
import store from '../../store/index.js'
import starReport from '../../api/star-report.api'
import Vue from 'vue'
import messageModal from '../common/message-modal.vue'

export default {
  name: 'starReportEditor',
  components: {
    spinner,
    messageModal,
    wizard
  },
  props: {
    'team_report_id': Number,
    'team_id': Number
  },
  data () {
    return {
      'star_actions': [],
      'star_injuries': [],
      'error_msg': null,
      'isInit': false,
      'showMessage': false
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser',
      'playerList'
    ]),
    ...mapGetters({
      current: 'starReportList'
    })
  },
  methods: {
    initDatas () {
      if (this.isInit === true) {
        return
      }
      this.star_actions = this.current.filter(sr => {
        return sr.rostered_star_player === null
      })
      let frontId = 1
      this.star_actions.forEach(action => {
        action.front_id = frontId
        frontId = frontId + 1
      })
      this.isInit = true
    },
    // ajoute un joueur du type qui va bien
    addActionLine (line) {
      let action = {}

      action.star_name = ''
      action.nb_pass = 0
      action.nb_td = 0
      action.nb_int = 0
      action.nb_cas = 0
      action.mvp = false
      action.nb_foul = 0
      action.nb_red_card = 0
      action.injury_type = null
      if (this.star_actions.length === 0) {
        action.front_id = 1
        Vue.set(this.star_actions, 0, action)
      } else {
        action.front_id = this.star_actions[this.star_actions.length - 1].front_id + 1
        Vue.set(this.star_actions, this.star_actions.length, action)
      }
      action.team_report = this.team_report_id
    },
    removeActionLine ($event) {
      console.log($event)
      if (!$event.currentTarget.id) {
        return
      }
      console.log('coucou')
      var gcpt = 0
      this.star_actions.forEach(action => {
        if ((action.front_id !== undefined) && (action.front_id === parseInt($event.currentTarget.id, 10))) {
          // si l'actionLine a un Id, c'est qu'elle vient du back, on envoie donc un delete
          if (action.id) {
            this.star_actions.splice(gcpt, 1)
            starReport.api.deleteStarReport(action.id)
            .then(reponse => {
            }, error => {
              console.log('impossible to delete player report')
              console.log(error)
            })
          } else {
            // sinon on supprime juste la ligne du tableau
            this.star_actions.splice(gcpt, 1)
          }
        }
        gcpt++
      })
    },
    validate (withReload) {
      if (this.star_actions.length === 0) {
        return
      }

      // on supprime les lignes vides
      let cpt = 0
      this.star_actions.forEach(report => {
        if (report.injury_type === 'null') {
          report.injury_type = null
        }
        if ((report.star_name === undefined) || (report.star_name === '')) {
          this.star_actions.splice(cpt, 1)
        } else {
          delete report.front_id
        }
        cpt++
      })
      // on trie les nouveaux rapports des existants
      let newReports = []
      let existingReports = []
      this.star_actions.forEach(report => {
        if (report.id) {
          existingReports.push(report)
        } else {
          newReports.push(report)
        }
      })

      // si n'a pas de rapports existant
      if (newReports.length !== 0) {
       // on creé en masse les lignes ui n'ont pas d'id
        console.log('creation en masse')
        this.createNewReports(newReports, withReload)
      }
      if (existingReports.length !== 0) {
          // sinon on update en masse les ligne qui ont un id
        console.log('update en masse')
        this.updateExistingReports(existingReports, withReload)
      }
    },
    createNewReports (reportsArray, withReload) {
      if (reportsArray.length === 0) {
        // cas on l'on enregistre une liste vide...
        store.dispatch('getStarReportListForTeamReport', this.team_report_id)
        this.isInit = false
        this.showMessage = true
      } else {
        starReport.api.createStarReport(reportsArray)
        .then(response => {
          if (withReload === true) {
            store.dispatch('getStarReportListForTeamReport', this.team_report_id)
          }
          this.isInit = false
          this.showMessage = true
        }, error => {
          console.log('cannot create star report')
          console.log(error)
        })
      }
    },
    updateExistingReports (reportsArray, withReload) {
      if (reportsArray.length === 0) {
        // cas on l'on enregistre une liste vide...
        store.dispatch('getStarReportListForTeamReport', this.team_report_id)
        this.isInit = false
        this.showMessage = true
      } else {
        starReport.api.bulkUpdateStarReport(reportsArray)
        .then(response => {
          if (withReload === true) {
            store.dispatch('getStarReportListForTeamReport', this.team_report_id)
          }
        }, error => {
          console.log('cannot update star report')
          console.log(error)
        })
      }
    },
    getRosterIcon () {
      return '/static/imgs/team-icons/' + this.team.ref_roster.replace(/\s+/, '') + '.png'
    }
  },
  created () {
    store.dispatch('getStarReportListForTeamReport', this.team_report_id)
    store.subscribe((mutation, state) => {
      if (mutation.type === 'refreshStarReports') {
        if (!this.isInit) {
          this.initDatas()
        }
      }
    })
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-team-name {
    font-size: 1.3rem;
}
.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tr td{
    padding: 0.5rem 0.2rem;
    text-align: center;
    font-size:0.7rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.note {
 font-size: 0.6rem;
}

</style>



// WEBPACK FOOTER //
// star-report-editor.vue?645c6e22